import React from "react";
import {testStatusState} from "../../states/states";
import {useRecoilValue} from "recoil";
import {
    currentTestState, numberOfRootQuestionState, currentQuestionIndexState
} from "../../states/test_progress_states";
import {testStatusNames, testTypes, routeNames, lessonTypes} from "../../config/constants";
import {useLocation} from 'react-router-dom'

/**
 * Quản lý trạng thái ẩn hiện của các đối tượng liên quan đến quá trình làm bài:
 * - progressBar
 * - Slide bar
 * - clock
 * @param BaseComponent
 * @returns {function(*): *}
 */
const withHeaderLogic = BaseComponent => (props) => {
    const {testCode, lessonCode} = props;
    let location = useLocation();
    const pathName = location.pathname;
    const isResultPage = pathName === routeNames.RESULT_LIST;
    const isResultDetail = pathName === routeNames.RESULT_DETAIL;
    const testStatus = useRecoilValue(testStatusState);
    const currentTestData = useRecoilValue(currentTestState);
    const numberOfRootQuestion = useRecoilValue(numberOfRootQuestionState);
    const currentQuestionIndex = useRecoilValue(currentQuestionIndexState);


    const showClockTestTypes = [testTypes.KIEM_TRA, testTypes.THI_CU];
    const showSlideTestTypes = [testTypes.THI_CU];
    const showProcessBarLessonTypes = [lessonTypes.KT_CUOI_KY];
    const showSlideLessonTypes = [lessonTypes.KT_CUOI_KY];

    const testTypeCode = currentTestData ? (testCode ? currentTestData.testTypeId : currentTestData.lessonTypeId) : "";
    const lessonTypeCode = currentTestData ? (lessonCode ? currentTestData.lessonTypeId : currentTestData.lessonTypeId) : "";

    const isInTestProgress = pathName === routeNames.START && testStatus.current_status === testStatusNames.TEST_IN_PROGRESS_STATUS && currentQuestionIndex <= numberOfRootQuestion;

    const isShowClock = isInTestProgress;// && showClockTestTypes.indexOf(testTypeCode) !== -1;

    let isShowSlide = false;
    let isShowProcessBar = false;
    if (testCode) {
        isShowSlide = isInTestProgress && showSlideTestTypes.indexOf(testTypeCode) !== -1;
        isShowProcessBar = isInTestProgress && showSlideTestTypes.indexOf(testTypeCode) === -1;
    }
    if (lessonCode) {
        isShowSlide = isInTestProgress && showSlideLessonTypes.indexOf(testTypeCode) !== -1;
        isShowProcessBar = isInTestProgress && showProcessBarLessonTypes.indexOf(lessonTypeCode) === -1;
    }

    const isShowButtonHome = !isInTestProgress;

    const isShowButtonViewResult = pathName === routeNames.START && !isInTestProgress;

    return (
        <React.Fragment>
            <BaseComponent {...props} isShowClock={isShowClock} isShowSlide={isShowSlide}
                           isShowProcessBar={isShowProcessBar} isShowButtonHome={isShowButtonHome}
                           isResultPage={isResultPage} isResultDetail={isResultDetail}
                           isShowButtonViewResult={isShowButtonViewResult}/>
        </React.Fragment>
    );
};

export default withHeaderLogic;
